import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from 'app/services/http.service';
import jwt_decode from 'jwt-decode';
import { MessageService } from 'primeng/api';

declare var $: any;

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
    focus;
    focus1;
    focus2;
    test: number = new Date().getFullYear();
    private toggleButton;
    private sidebarVisible: boolean;
    private nativeElement: Node;
    email: string = '';
    password: string;
    imagenFondo: string;

    constructor(
        private element: ElementRef,
        private http: HttpService,
        private activatedRoute: ActivatedRoute,
        public router: Router,
        private messageService: MessageService) {
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;
    }

    checkFullPageBackgroundImage() {
        var $page = $('.full-page');
        var image_src = $page.data('image');

        let fotos = [
            './assets/img/bg/fondo1.jpg',
            './assets/img/bg/fondo2.jpg',
            './assets/img/bg/fondo3.jpg',
            './assets/img/bg/fondo4.jpg',
            './assets/img/bg/fondo5.jpg',
            './assets/img/bg/fondo6.jpg',
            './assets/img/bg/fondo7.jpg',
            './assets/img/bg/fondo8.jpg',
            './assets/img/bg/fondo9.jpg',
            './assets/img/bg/fondo10.jpg',
        ]
        // let fotos = []

        let cantidadFotos = fotos.length

        let rdn = Math.floor(Math.random() * cantidadFotos)
        console.log('cantidadFotos', cantidadFotos);
        console.log('rdn', rdn);

        image_src = fotos[rdn]

        if (image_src !== undefined) {
            var image_container = '<div class="full-page-background" style="background-image: url(' + image_src + ') "/>'
            $page.append(image_container);
        }
    };

    ngOnInit() {
        console.log('Login ngOnInit');

        this.checkFullPageBackgroundImage();
        var body = document.getElementsByTagName('body')[0];
        body.classList.add('login-page');
        var navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];

        setTimeout(function () {
            // after 1000 ms we add the class animated to the login/register card
            $('.card').removeClass('card-hidden');
        }, 700)

        this.activatedRoute.params.subscribe(params => {
            let aux = params['prohibido'];
            console.log('aux', aux);
            if (aux = 'true') {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Este usuario no puede ingresar a esta plataforma' });
            }
        })

    }

    login() {
        //console.log('this.email', this.email);
        this.email = this.email.trim()

        this.http.loginService(this.email, this.password).subscribe((data: any) => {

            //La API de Controlguard no trae los datos codificados con JWT
            let datos: any = jwt_decode(data)

            this.http.setLocalstorage('userDataAdmin', JSON.stringify(datos))

            // El JWT tal cual, sin decodificar. Hasta ahora solo se guardaba el payload
            // ya decodificado, así que no había con qué firmar las llamadas: la auditoría
            // del backend registraba los cambios como 'NO IDENTIFICADO'.
            this.http.setLocalstorage('token', data)

            console.log('datos', datos);

            if (!datos.usuario.Habilitado) {
                console.log('Usuario no habilitado');
                return;
            }

            //console.log(JSON.stringify(this.cookieService.get('userDataAdmin')))
            let exp = (datos.exp * 1000) - 60000
            //console.log('exp', new Date(exp));

            let now = new Date().getTime()

            this.http.setLocalstorage('usuario', JSON.stringify(datos.usuario))

            this.router.navigateByUrl('home')

        }, (err => {
            console.log('Error:', err);
            //this.toastrService.error(err.error, 'Error')
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error });
            this.password = '';
        }))
    }

    ngOnDestroy() {
        var body = document.getElementsByTagName('body')[0];
        body.classList.remove('login-page');
    }

    sidebarToggle() {
        var toggleButton = this.toggleButton;
        var body = document.getElementsByTagName('body')[0];
        var sidebar = document.getElementsByClassName('navbar-collapse')[0];
        if (this.sidebarVisible == false) {
            setTimeout(function () {
                toggleButton.classList.add('toggled');
            }, 500);
            body.classList.add('nav-open');
            this.sidebarVisible = true;
        } else {
            this.toggleButton.classList.remove('toggled');
            this.sidebarVisible = false;
            body.classList.remove('nav-open');
        }
    }
}
